// @ts-ignore
import Modal from "modal-enhanced-react-native-web";
import ModalRN from "react-native-modal";

const WPModal = Modal;

export default WPModal as ModalRN;
